import _ from "lodash";
import { CANVAS_IDS, KONVA_EVENTS } from "../Konva/KonvaConstants";

/**
 *
 * @param {*} konva
 * @description this function handle hide and show of context menu
 */
export const maintainElementContextMenu = (
  konva,
  contextRef,
  setContextMenuNode
) => {
  const transformer = _.get(konva, "transformer");
  if (!transformer || !contextRef.current) return;

  // * on attaching transformer show context menu
  const showContextMenu = () => {
    if (!transformer || !contextRef.current) return;

    const node = _.first(transformer.getNodes());
    if (!node) return;

    if (_.includes(node.name(), `#${CANVAS_IDS.LABEL_ARROW}`)) {
      // * Hiding context menu for Arrow node
      hideContextMenu();
      setContextMenuNode(node);
      return;
    }

    contextRef.current.style.display = "flex";
    contextRef.current.style.opacity = 0;

    setContextMenuNode(node);

    setTimeout(() => {
      if (!transformer || !contextRef.current) return;
      contextRef.current.style.opacity = 1;
      const transformerWidth = transformer.width();
      const contextMenuWidth = contextRef.current.getBoundingClientRect().width;
      const widthDifference = contextMenuWidth - transformerWidth;

      const x = transformer.x() - widthDifference / 2;
      const y =
        transformer.y() - _.get(contextRef.current, "clientHeight", 0) - 8;
      const position = { x, y };

      contextRef.current.style.top = `${position.y}px`;
      contextRef.current.style.left = `${position.x}px`;
    }, 100);
  };

  // * on detaching transformer hide context menu
  const hideContextMenu = () => {
    setContextMenuNode(null);

    if (!contextRef.current) return;
    contextRef.current.style.display = "none";
  };

  // * showing events
  konva.transformer.on(KONVA_EVENTS.TRANSFORMERATTACHED, showContextMenu);

  // * hiding events
  konva.stage.on(KONVA_EVENTS.DRAGMOVE, hideContextMenu);
  konva.transformer.on(KONVA_EVENTS.TRANSFORM, hideContextMenu);
  konva.transformer.on(KONVA_EVENTS.TRANSFORMEND, hideContextMenu);
  konva.transformer.on(KONVA_EVENTS.TRANSFORMERDETACHED, hideContextMenu);

  // * Initially hiding if any last render context menu persist
  return hideContextMenu();
};
